export default "__VITE_ASSET__cff49bcb__"